module.exports = __webpack_public_path__ + "static/media/dinosaur(9).1da8dce6.PNG";